import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { OpportunityCard } from "@/components/Cards";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import PageSEO from "@/components/PageSEO";

const TABS = [
  { key: "all", label: "All" },
  { key: "real_estate", label: "Real Estate" },
  { key: "agriculture", label: "Agriculture" },
  { key: "strategic", label: "Strategic" },
  { key: "circle", label: "Investment Circle" },
];

export default function Opportunities() {
  const [all, setAll] = useState([]);
  useEffect(() => { http.get("/opportunities").then(r => setAll(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageSEO
        title="Open Investment Opportunities"
        description="Browse Mayoto's structured investment opportunities across Real Estate, Agriculture, Strategic Business and the Investment Circle. Minimum from NGN 2,000. Transparent terms, published risk information."
        canonicalPath="/investments"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">INVESTMENT OPPORTUNITIES</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="opps-title">
            Current opportunities on Mayoto.
          </h1>
          <p className="mt-5 text-slate-600 max-w-2xl">
            Explore structured investment opportunities across three focus sectors. Every opportunity ships with clear terms, timelines and risk information.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide">
          <Tabs defaultValue="all">
            <TabsList className="bg-slate-100 p-1 rounded-full flex-wrap h-auto" data-testid="opps-tabs">
              {TABS.map(t => (
                <TabsTrigger key={t.key} value={t.key} className="rounded-full data-[state=active]:bg-[#0a1128] data-[state=active]:text-white px-5 py-2" data-testid={`opps-tab-${t.key}`}>
                  {t.label}
                </TabsTrigger>
              ))}
            </TabsList>
            {TABS.map(t => {
              const list = t.key === "all" ? all : all.filter(o => o.category === t.key);
              return (
                <TabsContent key={t.key} value={t.key} className="mt-10">
                  {list.length === 0 ? (
                    <div className="text-center py-16 text-slate-500 border border-dashed border-slate-200 rounded-2xl">
                      No opportunities in this category are open right now. Please check back soon.
                    </div>
                  ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {list.map(o => <OpportunityCard key={o.id} opp={o} />)}
                    </div>
                  )}
                </TabsContent>
              );
            })}
          </Tabs>
        </div>
      </section>
    </div>
  );
}
